import { useSelector } from "react-redux";
import { IAppState } from "../store";

export const useUserFavoritesSelector = () =>
  useSelector((state: IAppState) => state.user.favorites);
